import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyDXS05Rd_FdQRuty3LYcGmNMr5XcTuC_3M",
  authDomain: "clipperkingssj.firebaseapp.com",
  databaseURL: "https://clipperkingssj-default-rtdb.firebaseio.com",
  projectId: "clipperkingssj",
  storageBucket: "clipperkingssj.firebasestorage.app",
  messagingSenderId: "678236938856",
  appId: "1:678236938856:web:e100c12bdbb642dc2591dd",
  measurementId: "G-SYXKZ4VRGW"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const analytics = getAnalytics(app);
